import { twMerge } from 'tailwind-merge';
export function ModalTitle(props) {
    return <span className={twMerge('text-center text-xl font-mono font-bold', props.className)}>{props.children}</span>;
}
